import { Organization } from '@/types/organization';
import { ProjectClass } from '@/types/projectClass';
import { api } from '@/services/api/axios/instance';
import { AxiosResponse } from 'axios';

type GetListParams = {
  data: {
    organizationId: Organization['id'];
  };
};

export const projectClassesApi = {
  getList: async (config: GetListParams): Promise<ProjectClass[]> => {
    const { organizationId } = config.data;
    const path = `organizations/${organizationId}/project_classes/bundled`;

    const response: AxiosResponse<{
      projectClasses: ProjectClass[];
    }> = await api.get(path, config);

    return response.data.projectClasses;
  },
};
